export default __webpack_public_path__ + "assets/bbb418c8e682da20f7be95bdc215bf97.jpg";